import { render, staticRenderFns } from "./ConfirmDialogTest.vue?vue&type=template&id=1e6c72d5&scoped=true"
import script from "./ConfirmDialogTest.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogTest.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialogTest.vue?vue&type=style&index=0&id=1e6c72d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c72d5",
  null
  
)

export default component.exports